/* 
 * Export component file to be used on project
*/

import ProfileEducation from './ProfileEducation.js';
export default ProfileEducation;
